export const ROUTERS = {
  HOME: "/home",
  NEW_PREDICTION: "/newPrediction",
  MY_PREDICTION: "/myPrediction",
  ERROR: "/error",
};
